module.exports = __webpack_public_path__ + "static/hide-subcategories-in-products-by-category-block-bd44803474c8eeeb66595a5510401895.jpg";